import React from 'react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { cn } from '@/lib/utils'

export const CustomSelect = React.forwardRef(
  ({ options, onChange, checkItemDisabled, ...props }, ref) => {
    const handleChange = (value) => {
      if (!options || !options.length) {
        return
      }

      const option = options.find((x) => x.value === value)
      onChange(value, option)
    }

    return (
      <Select
        {...props}
        value={props?.option?.value || props.value}
        onValueChange={handleChange}
      >
        <SelectTrigger
          ref={ref}
          className={cn(
            !props.value && 'text-muted-foreground',
            props.triggerClassName,
          )}
        >
          <SelectValue placeholder={props.placeholder ?? 'Chọn'} />
        </SelectTrigger>
        <SelectContent>
          {props.defaultValue && (
            <SelectItem key="item_0" value={props.defaultValue}>
              {props.defaultValueLabel ?? 'Chọn'}
            </SelectItem>
          )}
          {options.map((option, index) => (
            <SelectItem
              key={`item_${index + 1}`}
              value={option.value}
              disabled={checkItemDisabled?.(option) ?? false}
            >
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    )
  },
)

CustomSelect.displayName = 'CustomSelect'
